/**
 * Approved brand artwork (RASTER, TEMPORARY).
 *
 * Extracted from the supplied identity guide ("دليل الهوية Johnson.pdf",
 * pages 3–8) at native resolution. Artwork was not redrawn, recoloured or
 * reinterpreted: backgrounds were converted to transparency and isolated
 * specks removed. The Arabic wordmark was cropped above the tagline line,
 * because that tagline contains a distributor/exclusivity claim that is not
 * approved for production (decision 3).
 *
 * ⚠ Approved vector master logo required before final production launch.
 *    Replace these files (same names, SVG preferred) — no interface changes needed.
 *
 * Note: the artwork's blue as extracted is the identity-guide blue, which is
 * also the digital primary colour (decision 2, BRAND_COLORS.blue). The
 * artwork itself is never recoloured.
 */
import johnsonLockupBlue from './johnson-lockup-blue.png';
import johnsonLockupWhite from './johnson-lockup-white.png';
import johnsonMarkBlue from './johnson-mark-blue.png';
import johnsonMarkWhite from './johnson-mark-white.png';
import wordmarkArBlue from './qinaa-wordmark-ar-blue.png';
import wordmarkArWhite from './qinaa-wordmark-ar-white.png';

export interface BrandAsset {
  src: string;
  width: number;
  height: number;
}

export const brandAssets = {
  johnsonLockup: {
    onLight: { src: johnsonLockupBlue, width: 950, height: 307 },
    onDark: { src: johnsonLockupWhite, width: 950, height: 307 },
  },
  johnsonMark: {
    onLight: { src: johnsonMarkBlue, width: 255, height: 193 },
    onDark: { src: johnsonMarkWhite, width: 255, height: 193 },
  },
  wordmarkAr: {
    onLight: { src: wordmarkArBlue, width: 1015, height: 184 },
    onDark: { src: wordmarkArWhite, width: 1015, height: 184 },
  },
} as const satisfies Record<string, Record<'onLight' | 'onDark', BrandAsset>>;

export const BRAND_ASSET_STATUS = {
  isVectorMaster: false,
  note: 'Approved vector master logo required before final production launch.',
} as const;
